import { AxiosRequestHeaders } from 'axios'

import { post } from '@/utils/axios'

const uploadToS3Bucket = async (formData: FormData) => {
  try {
    const result = await post<{ filepath: string }>(
      '/common/v1/file_upload',
      formData,
      { 'Content-Type': 'multipart/form-data' } as unknown as AxiosRequestHeaders
    )
    if (result && result.filepath) {
      return result.filepath
    }
  } catch {
    return
  }
}

export default uploadToS3Bucket
